<template>
  <router-link
    style="text-decoration: none"
    :to="{
      name: 'articleById',
      params: {
        name: `${article.name.replace(/[?]/g, '').toLowerCase().replace(/ /g, '-')}-${article.id}`,
      },
    }"
  >
    <div class="article-item">
      <div class="article-item-icon">
        <mdicon size="25" name="file-document-outline" />
        <!-- <img
          v-if="article.imageUrl"
          :src="article.imageUrl"
          height="150"
          width="150"
          alt="Article"
        />
        <img
          v-else
          src="@/assets/article.png"
          height="150"
          width="150"
          alt="Article"
        /> -->
      </div>
      <div class="article-item-info">
        <h2>{{ article.name }}</h2>
        <div class="d-flex">
          <span class="mr-2">
            <p v-if="isPublicationDate" class="details">
              Publicado em {{ article.publicationDate | formatDate }}
            </p>
          </span>
          <span>
            <p v-if="isViews" class="details">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="eye"
                class="svg-inline--fa fa-eye fa-w-18"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
              >
                <path
                  fill="currentColor"
                  d="M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
                ></path>
              </svg>
              {{ article.views }} visualizações
            </p>
          </span>
        </div>
        <!-- <p class="mt-2">{{ article.description }}</p> -->
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "ArticleItem",
  props: ["article", "isPublicationDate", "isViews"],
};
</script>

<style>
.article-item {
  margin-bottom: 5px;
  background-color: #fff;
  padding: 10px 20px;
  display: flex;
  align-items: flex-start;
  text-decoration: none;
  /* border: 1px solid rgba(0, 0, 0, 0.2);
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15); */
}

.article-item:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

/* .article-item a {
  display: flex;
  align-items: flex-start;
  text-decoration: none;
  color: #000;
} */

.article-item-info h2 {
  color: #545454;
  font-size: 1rem;
  margin-bottom: 0;
}

.article-item-info .details {
  font-size: 0.7rem;
}

.article-item-icon {
  padding-top: 2px;
  margin-right: 5px;
  color: #545454;
  /* border-right: 1px solid #aaa; */
}

.article-item-info {
  display: flex;
  align-self: stretch;
  flex-direction: column;
}

.article-item-info p {
  font-size: 0.8rem;
  flex: 1;
  color: #555;
  margin: 0;
}
</style>